export default class JSONDownloader {
  /**
   * Downloads a JSON string or object as a file.
   * @param {string|object} data - The content to download.
   * @param {string} filename - The desired name of the file (e.g., 'data.json').
   */
  static download(data, filename = 'data.json') {
    // 1. Ensure the data is a string
    const jsonString = typeof data === 'string'
      ? data
      : JSON.stringify(data, null, 2);

    // 2. Create a Blob with the JSON content and set the MIME type
    const blob = new Blob([jsonString], { type: 'application/json' });

    // 3. Create a temporary URL for the Blob
    const url = URL.createObjectURL(blob);

    // 4. Create a hidden <a> element to trigger the download
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;

    // 5. Append to body, click, and immediately remove
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // 6. Clean up the URL object to free up memory
    URL.revokeObjectURL(url);
  }
}
